// ----------------------------------------------------------------------

import { Z_INDEX } from '../../constants/zIndex';

export default function Popover(theme) {
  return {
    MuiPopover: {
      styleOverrides: {
        root: {
          zIndex: Z_INDEX.MAX, // Ensure popover root appears above everything
        },
        paper: {
          boxShadow: theme.customShadows.z12,
          zIndex: Z_INDEX.MAX, // Ensure popover paper appears above everything
        },
      },
    },
  };
}
